export const AUTH_SUCCESS_POPUP_EVENT = "dr-hoffmann-auth-success";
export const AUTH_SUCCESS_POPUP_KEY = "dr_hoffmann_auth_success_popup";

export const AUTH_SUCCESS_POPUP_COPY = {
  login: {
    kicker: "Angemeldet",
    title: "Willkommen zurück",
    message: "Du hast dich erfolgreich angemeldet.",
  },
  logout: {
    kicker: "Abgemeldet",
    title: "Bis bald",
    message: "Du hast dich erfolgreich abgemeldet.",
  },
};

const normalizeKind = (kind) =>
  Object.prototype.hasOwnProperty.call(AUTH_SUCCESS_POPUP_COPY, kind) ? kind : "login";

export const queueAuthSuccessPopup = (kind) => {
  if (typeof window === "undefined") return;

  const normalizedKind = normalizeKind(kind);
  try {
    window.sessionStorage.setItem(AUTH_SUCCESS_POPUP_KEY, normalizedKind);
  } catch {
    // The custom event still lets the visible app react when storage is blocked.
  }

  window.dispatchEvent(
    new CustomEvent(AUTH_SUCCESS_POPUP_EVENT, {
      detail: { kind: normalizedKind },
    })
  );
};

export const consumeQueuedAuthSuccessPopup = () => {
  if (typeof window === "undefined") return null;

  try {
    const storedKind = window.sessionStorage.getItem(AUTH_SUCCESS_POPUP_KEY);
    window.sessionStorage.removeItem(AUTH_SUCCESS_POPUP_KEY);
    return storedKind ? normalizeKind(storedKind) : null;
  } catch {
    return null;
  }
};
